import { TreatyType, TreatyTypeEnum } from '../models/treaty.model';

type NewTreatyTextsDetais = {
  id: TreatyType;
  title: string;
  actionTitle: string;
  info: string;
  description: string;
  buttonText?: string;
};

type NewTreatyTexts = {
  casualty: NewTreatyTextsDetais;
  property: NewTreatyTextsDetais;
};

export const NEW_TREATY_TEXTS: NewTreatyTexts = {
  casualty: {
    id: TreatyTypeEnum.Casualty,
    title: 'Bordereau with Insured Names',
    actionTitle: 'Fill in the data with Insured Name',
    info: 'Suited for Casualty',
    description:
      'The assessment can only proceed if the names of the insured companies and their corresponding limits/premiums are available',
    buttonText: 'Proceed with Insured Names',
  },

  property: {
    id: TreatyTypeEnum.Property,
    title: 'Bordereau with Occupancy Names',
    actionTitle: 'Fill in the data with Occupancy Names',
    info: 'Suited for Property',
    description:
      'The assessment can only proceed if the occupancy Information, the country, and the corresponding limits/premiums of the risks are available',
    buttonText: 'Proceed with Occupancies',
  },
};
